export const clockInCompany = ({ companies, companyId, now = new Date() }) => {
  if (!companies?.[companyId]) return companies;

  return {
    ...companies,
    [companyId]: {
      ...companies[companyId],
      isClockedIn: true,
      clockInTime: now.toISOString()
    }
  };
};

export const createAttendanceLog = ({ clockInISO, now = new Date(), lang = 'en' }) => {
  const clockIn = new Date(clockInISO);
  const diffSeconds = Math.max(0, Math.floor((now - clockIn) / 1000));

  return {
    id: Date.now(),
    date: now.toLocaleDateString(lang === 'ar' ? 'ar-EG' : 'en-US', { year: 'numeric', month: 'short', day: 'numeric' }),
    clockIn: clockIn.toLocaleTimeString(lang === 'ar' ? 'ar-EG' : 'en-US', { hour: '2-digit', minute: '2-digit' }),
    clockOut: now.toLocaleTimeString(lang === 'ar' ? 'ar-EG' : 'en-US', { hour: '2-digit', minute: '2-digit' }),
    durationSeconds: diffSeconds
  };
};

export const formatAttendanceDuration = ({ durationSeconds, lang = 'en' }) => {
  const hours = Math.floor(durationSeconds / 3600);
  const minutes = Math.floor((durationSeconds % 3600) / 60);
  const seconds = durationSeconds % 60;

  return lang === 'ar'
    ? `${hours} \u0633\u0627\u0639\u0629 \u0648 ${minutes} \u062f\u0642\u064a\u0642\u0629 \u0648 ${seconds} \u062b\u0627\u0646\u064a\u0629`
    : `${hours}h ${minutes}m ${seconds}s`;
};

export const clockOutCompany = ({ companies, companyId, now = new Date(), lang = 'en' }) => {
  if (!companies?.[companyId]) return { companies, logItem: null, durationText: '' };

  const logItem = createAttendanceLog({
    clockInISO: companies[companyId].clockInTime,
    now,
    lang
  });

  const updatedCompanies = {
    ...companies,
    [companyId]: {
      ...companies[companyId],
      isClockedIn: false,
      clockInTime: null,
      attendanceLogs: [logItem, ...(companies[companyId].attendanceLogs || [])]
    }
  };

  return {
    companies: updatedCompanies,
    logItem,
    durationText: formatAttendanceDuration({ durationSeconds: logItem.durationSeconds, lang })
  };
};

export const removeAttendanceLog = ({ companies, companyId, logId }) => {
  if (!companies?.[companyId]) return companies;

  return {
    ...companies,
    [companyId]: {
      ...companies[companyId],
      attendanceLogs: (companies[companyId].attendanceLogs || []).filter(log => log.id !== logId)
    }
  };
};

export const clearAttendanceLogs = ({ companies, companyId }) => {
  if (!companies?.[companyId]) return companies;

  return {
    ...companies,
    [companyId]: {
      ...companies[companyId],
      attendanceLogs: []
    }
  };
};
